// Action Cable consumer for real-time Turbo Streams
import { createConsumer } from "@rails/actioncable"

export default createConsumer()
